












































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HTTP from '@/plugins/axios'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import { BoletoDTO } from '@/interfaces/Boleto.interface'

@Component
export default class ViewComprarBoletos extends Vue {
  private name: string = 'ViewComprarBoletos'
  private dialog: boolean = false
  private dialogPay: boolean = false
  private infoBoletos: BoletoDTO[] = []
  private infoBoletosVenta: any[] = []
  private step: number = 1
  private codigoDescuento: string = ''
  private selectDay: number = -1
  private showCreditCard: boolean = false
  private showOXXO: boolean = false
  private days: object = [
    'Jueves - 21/11/2019',
    'Viernes - 22/11/2019',
    'Sabado - 23/11/2019'
  ]
  private datosVenta: any = {
    nombre: 'Comprador',
    phone: '12345678911',
    email: 'comprador@hotmail.com',
    type: '',
    token_id: null,
    card: {
      number: '4242424242424242',
      name: 'Fulanito Pérez',
      exp_year: '2020',
      exp_month: '12',
      cvc: '123',
      address: {
        street1: 'Calle 123 Int 404',
        street2: 'Col. Condesa',
        city: 'Ciudad de Mexico',
        state: 'Distrito Federal',
        zip: '12345',
        country: 'Mexico'
      }
    }
  }

  private infoVenta: any = {
    adulto: {
      costo: 180,
      cantidad: 1,
      categoria: 'Adulto'
    },
    infantil: {
      costo: 90,
      cantidad: 0,
      categoria: 'Infantil'
    },
    discapacidad: {
      costo: 100,
      cantidad: 0,
      categoria: 'Discapacidad'
    }
  }

  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nueva Venta:',
      color: 'success'
    },
    update: {
      text: 'Modificado Venta:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }

  @Watch('datosVenta.nombre')
  private watchDatosVentaNombre (v: string) {
    this.datosVenta.card.name = v
  }

  @Watch('selectDay')
  private watchSelectDay (v: any) {
    if (v >= 0) {
      this.step = 2
    }
  }

  @Watch('codigoDescuento')
  private watchCodigoDescuento (v: any) {
    if (v.length > 0) {
      console.log('Aplicar Descuento', v)
    }
  }

  @Watch('dialogPay')
  private watchDialogPay (v: any) {
    if (!v) return
    this.createVenta()
  }

  @Watch('showOXXO')
  private watchShowOxxo (v: boolean) {
    if (v) {
      this.datosVenta.type = 'oxxo_cash'
      this.showCreditCard = false
    }
  }

  @Watch('showCreditCard')
  private watchShowCreditCard (v: boolean) {
    if (v) {
      this.datosVenta.type = 'card'
      this.showOXXO = false
    }
  }

  private createVenta () {
    if (this.datosVenta.type === 'card') {
      this.gTokenCard()
    } else {
      this.sendVenta()
    }
  }

  private sendVenta () {
    this.infoBoletos.forEach((bole) => {
      if (bole.quantity > 0) {
        for (let i = 1; i <= bole.quantity; i++) {
          this.infoBoletosVenta.push(bole)
        }
      }
    })
    const data: any = {
      infoBoletosVenta: this.infoBoletosVenta,
      infoBoletos: this.infoBoletos,
      datosVenta: this.datosVenta
    }

    HTTP.post('conekta/', data)
      .then((response) => {
        console.log('CreateBoleto :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.success.text + ' ' + this.datosVenta.nombre,
          color: this.textMSG.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e: any) => {
        console.log('CreateBoleto :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + this.datosVenta.nombre,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
      .finally(() => {
        this.dialogPay = false
        this.step = 4
      })
  }

  private addBoleto (item: any) {
    console.log('addBoleto :: ',  item.id)
    if (item.quantity < 0 ) {
      item.quantity = 1
    } else {
      ++item.quantity
    }
  }

  private get totalVenta () {
    let res = 0
    this.infoBoletos.forEach((boleto) => {
      res += boleto.quantity * boleto.cost
    })
    return res
  }

  private get totalBoletos () {
    let res = 0
    res += this.infoVenta.adulto.cantidad
    res += this.infoVenta.infantil.cantidad
    res += this.infoVenta.discapacidad.cantidad
    return res
  }

  private lessBoleto (item: any) {
    if (item.quantity <= 1 ) {
      item.quantity = 0
    } else {
      --item.quantity
    }
  }

  private getBoletos () {
    HTTP.get('boleto/')
      .then((response) => {
        console.log('getBoletos :: response :: ', response.data)
        response.data.forEach((dat: any) => {
          dat.quantity = 0
        })
        this.infoBoletos = response.data
      })
      .catch((e) => {
        console.log('getBoletos :: catch :: ', e.response.data)
      })
      .finally()
  }

  private async gTokenCard () {
    // @ts-ignore: Unreachable code error
    await Conekta.Token.create({
      card: {
        number: '4242424242424242',
        name: 'Fulanito Pérez',
        exp_year: '2020',
        exp_month: '12',
        cvc: '123',
        address: {
          street1: 'Calle 123 Int 404',
          street2: 'Col. Condesa',
          city: 'Ciudad de Mexico',
          state: 'Distrito Federal',
          zip: '12345',
          country: 'Mexico'
        }
      }
    }, (res: any) => {
      this.datosVenta.token_id = res.id
      console.log('Res :: ', res)
      this.sendVenta()
    }, (err: any) => {
      console.log('Err :: ', err)
    })
  }

  private beforeMount () {
    // @ts-ignore: Unreachable code error
    console.log('Conekta :: ', Conekta.setPublicKey('key_EtGH6Xpur2p8m2UzoCa2ueA'))
    console.log('beforeMount :: ', this.name)
    this.getBoletos()
  }
}
